import { render, staticRenderFns } from "./OnboardingLinkBankAccountLandingPage.vue?vue&type=template&id=c92f0150"
import script from "./OnboardingLinkBankAccountLandingPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingLinkBankAccountLandingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports